import { render, staticRenderFns } from "./StrategyFavorites.vue?vue&type=template&id=193b0620&scoped=true"
import script from "./StrategyFavorites.vue?vue&type=script&lang=js"
export * from "./StrategyFavorites.vue?vue&type=script&lang=js"
import style0 from "./StrategyFavorites.vue?vue&type=style&index=0&id=193b0620&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193b0620",
  null
  
)

export default component.exports